import { Injectable } from '@angular/core';
import { AzureConfig } from '../models/config';
import { BehaviorSubject } from 'rxjs';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class RoleService {
  blobDetails: AzureConfig = <AzureConfig>{};
  private role: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private schedulerProcessId: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private scadRoutes: any;
  constructor(
    private envService: EnvService,
    private http: HttpClient,
  ) {}

  getRoleDetails() {
    return this.http.get<any[]>('assets/cdn/json/role.json');
    // return this.http.get("assets/json/role.json");
    // let blobUrl = this.envService.bloburl;
    // const blobService = AzureStorage.Blob.createBlobServiceAnonymous(blobUrl);
    // return new Promise(resolve =>{
    //   blobService.getBlobToText('json','role.json',function(err,blobcontent,blob){
    //        resolve([
    //       {
    //           "role": "DBAD",
    //           "routes": [
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Create Candidate",
    //                   "path": "db/candidate-creation"
    //               },
    //               {
    //                   "subRole": "VLAD",
    //                   "menu": "Validation Check",
    //                   "path": "db/validation-lead"
    //               },
    //               {
    //                   "subRole": "DCAD",
    //                   "menu": "Duplication Check",
    //                   "path": "db/duplicationcheck-lead"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Parser Report",
    //                   "path": "db/parser-report"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "DB Report",
    //                   "path": "db/db-report"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Bulk Creation",
    //                   "path": "db/bulk-upload"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Links",
    //                   "path": "db/links"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "DBAS",
    //           "routes": [
    //               {
    //                   "subRole": "DBAS",
    //                   "menu": "Create Candidate",
    //                   "path": "db/candidate-creation"
    //               },
    //               {
    //                   "subRole": "VLAS",
    //                   "menu": "Validate Resume",
    //                   "path": "db/validation-associate"
    //               },
    //               {
    //                   "subRole": "DCAS",
    //                   "menu": "Duplication Check",
    //                   "path": "db/duplicationcheck-associate"
    //               },
    //               {
    //                   "subRole": "DBAS",
    //                   "menu": "Bulk Creation",
    //                   "path": "db/bulk-upload"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "SCAD",
    //           "hiringIdPaths": [
    //               {
    //                   "hiringId": "1",
    //                   "routes": [
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Scheduler Anchor Dashboard",
    //                           "path": "scheduler/admin",
    //                           "buttonName": null
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Interview Activity Uploads",
    //                           "path": "scheduler/interview-activity-uploads",
    //                           "buttonName": "To Be Scheduled Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "ROA Uploads",
    //                           "path": "scheduler/roa-uploads",
    //                           "buttonName": "Reject upload Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status Change Uploads",
    //                           "path": "scheduler/status-change-uploads",
    //                           "buttonName": "Status Change Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Decision Pending Uploads",
    //                           "path": "scheduler/dp-uploads",
    //                           "buttonName": "Decision Pending Upload"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Bulk Requisition Assignment",
    //                           "path": "scheduler/bulkReassignment-uploads",
    //                           "buttonName": null
    //                       },
    //             {
    //                           "subRole": "SCAD",
    //                           "menu": "Bulk WhatsApp Uploads",
    //                           "path": "scheduler/bulkwhatsapp-uploads",
    //                           "buttonName": null,
    //                           "templateOptions": [
    //                               {
    //                                   "key": "Interview_cancellation_template",
    //                                   "value": "Interview Cancellation Template",
    //                                   "whatsAppValue": "Interview_cancellation_bulkMessage"
    //                               },
    //                               {
    //                                   "key": "candidate_interest_check_template",
    //                                   "value": "Candidate Interest Template",
    //                                   "whatsAppValue": "candidate_interest_check_bulk"
    //                               }
    //                           ]
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status",
    //                           "path": "scheduler/upload-status",
    //                           "buttonName": null
    //                       }
    //                   ]
    //               },
    //               {
    //                   "hiringId": "2",
    //                   "routes": [
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status Change Uploads",
    //                           "path": "scheduler/status-change-uploads",
    //                           "buttonName": "Status Change Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status",
    //                           "path": "scheduler/upload-status",
    //                           "buttonName": null
    //                       }
    //                   ]
    //               },
    //               {
    //                   "hiringId": "4",
    //                   "routes": [
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "ROA Uploads",
    //                           "path": "scheduler/roa-uploads",
    //                           "buttonName": "Reject upload Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Bulk Email Uploads",
    //                           "path": "scheduler/bulkemail-uploads",
    //                           "buttonName": "Bulk Email Upload",
    //                           "templateOptions": [
    //                               {
    //                                   "name": "Notification of ROA",
    //                                   "activityId": 200201,
    //                                   "processId": 10
    //                               },
    //                 {
    //                                   "name": "General Notification",
    //                                   "activityId": 100010,
    //                                   "processId": 10
    //                               }
    //                           ]
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status",
    //                           "path": "scheduler/upload-status",
    //                           "buttonName": null
    //                       }
    //                   ]
    //               }
    //           ]
    //       },
    //       {
    //           "role": "SCAS",
    //           "routes": [
    //               {
    //                   "subRole": "SCAS",
    //                   "menu": "Dashboard",
    //                   "path": "scheduler/associate"
    //               }
    //           ],
    //           "processId": [
    //               40
    //           ]
    //       },
    //       {
    //           "role": "OFDA",
    //           "routes": [
    //               {
    //                   "subRole": "OFDA",
    //                   "menu": "Dashboard",
    //                   "path": "offerdb/associate"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "RECRUITER",
    //           "routes": [
    //               {
    //                   "subRole": "RECRUITER",
    //                   "menu": "Dashboard",
    //                   "path": "recruiter/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "RM",
    //           "routes": [
    //               {
    //                   "subRole": "RM",
    //                   "menu": "Dashboard",
    //                   "path": "rm/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "CnB",
    //           "routes": [
    //               {
    //                   "subRole": "CnB",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/cnbdashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "CnBAdmin",
    //           "routes": [
    //               {
    //                   "subRole": "CnBAdmin",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/cnbadmin"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "CnBExecutive",
    //           "routes": [
    //               {
    //                   "subRole": "CnBExecutive",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/cnbdashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "RH",
    //           "routes": [
    //               {
    //                   "subRole": "RH",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "TPD",
    //           "routes": [
    //               {
    //                   "subRole": "TPD",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/tpddashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "Rec_Lead",
    //           "routes": [
    //               {
    //                   "subRole": "Rec_Lead",
    //                   "menu": "Dashboard",
    //                   "path": "reclead/posting-approval"
    //               }
    //           ]
    //       },
    //     {
    //           "role": "RecLeadAM",
    //           "routes": [
    //               {
    //                   "subRole": "RecLeadAM",
    //                   "menu": "Dashboard",
    //                   "path": "recleadam/posting-approval"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "HR Operations",
    //           "routes": [
    //               {
    //                   "subRole": "HR Operations",
    //                   "menu": "Dashboard",
    //                   "path": "hroperations/resume-upload"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "Operations",
    //           "routes": [
    //               {
    //                   "subRole": "Operations",
    //                   "menu": "Dashboard",
    //                   "path": "operations/edit-source"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "OD",
    //           "routes": [
    //               {
    //                   "subRole": "OD",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/bpmoddashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "HiringManager",
    //           "routes": [
    //               {
    //                   "subRole": "HiringManager",
    //                   "menu": "Dashboard",
    //                   "path": "hiringmanager/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "Offer_Admin",
    //           "routes": [
    //               {
    //                   "subRole": "OfferAdmin",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/adminOffer"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "IAPRec",
    //           "routes": [
    //               {
    //                   "subRole": "IAPRec",
    //                   "menu": "Dashboard",
    //                   "path": "iaprecruiter/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "BGC Approver 1",
    //           "routes": [
    //               {
    //                   "subRole": "BGC Approver 1",
    //                   "menu": "Dashboard",
    //                   "path": "/offermicro/bgc/approval"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "BGC Approver 2",
    //           "routes": [
    //               {
    //                   "subRole": "BGC Approver 2",
    //                   "menu": "Dashboard",
    //                   "path": "/offermicro/bgc/approval"
    //               }
    //           ]
    //       },
    //       {
    //          "role": "Docket Anchor",
    //          "routes": [
    //             {
    //               "subRole": "Docket Anchor",
    //                "menu": "Dashboard",
    //                "path": "docketanchor/dashboard"
    //             }
    //           ]
    //       }

    //   ])
    //   })
    // });

    //     resolve([
    //       {
    //           "role": "DBAD",
    //           "routes": [
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Create Candidate",
    //                   "path": "db/candidate-creation"
    //               },
    //               {
    //                   "subRole": "VLAD",
    //                   "menu": "Validation Check",
    //                   "path": "db/validation-lead"
    //               },
    //               {
    //                   "subRole": "DCAD",
    //                   "menu": "Duplication Check",
    //                   "path": "db/duplicationcheck-lead"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Parser Report",
    //                   "path": "db/parser-report"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "DB Report",
    //                   "path": "db/db-report"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Bulk Creation",
    //                   "path": "db/bulk-upload"
    //               },
    //               {
    //                   "subRole": "DBAD",
    //                   "menu": "Links",
    //                   "path": "db/links"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "DBAS",
    //           "routes": [
    //               {
    //                   "subRole": "DBAS",
    //                   "menu": "Create Candidate",
    //                   "path": "db/candidate-creation"
    //               },
    //               {
    //                   "subRole": "VLAS",
    //                   "menu": "Validate Resume",
    //                   "path": "db/validation-associate"
    //               },
    //               {
    //                   "subRole": "DCAS",
    //                   "menu": "Duplication Check",
    //                   "path": "db/duplicationcheck-associate"
    //               },
    //               {
    //                   "subRole": "DBAS",
    //                   "menu": "Bulk Creation",
    //                   "path": "db/bulk-upload"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "SCAD",
    //           "hiringIdPaths": [
    //               {
    //                   "hiringId": "1",
    //                   "routes": [
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Scheduler Anchor Dashboard",
    //                           "path": "scheduler/admin",
    //                           "buttonName": null
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Interview Activity Uploads",
    //                           "path": "scheduler/interview-activity-uploads",
    //                           "buttonName": "To Be Scheduled Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "ROA Uploads",
    //                           "path": "scheduler/roa-uploads",
    //                           "buttonName": "Reject upload Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status Change Uploads",
    //                           "path": "scheduler/status-change-uploads",
    //                           "buttonName": "Status Change Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Decision Pending Uploads",
    //                           "path": "scheduler/dp-uploads",
    //                           "buttonName": "Decision Pending Upload"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Bulk Requisition Assignment",
    //                           "path": "scheduler/bulkReassignment-uploads",
    //                           "buttonName": null
    //                       },
    //             {
    //                           "subRole": "SCAD",
    //                           "menu": "Bulk WhatsApp Uploads",
    //                           "path": "scheduler/bulkwhatsapp-uploads",
    //                           "buttonName": null,
    //                           "templateOptions": [
    //                               {
    //                                   "key": "Interview_cancellation_template",
    //                                   "value": "Interview Cancellation Template",
    //                                   "whatsAppValue": "Interview_cancellation_bulkMessage"
    //                               },
    //                               {
    //                                   "key": "candidate_interest_check_template",
    //                                   "value": "Candidate Interest Template",
    //                                   "whatsAppValue": "candidate_interest_check_bulk"
    //                               }
    //                           ]
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status",
    //                           "path": "scheduler/upload-status",
    //                           "buttonName": null
    //                       }
    //                   ]
    //               },
    //               {
    //                   "hiringId": "2",
    //                   "routes": [
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status Change Uploads",
    //                           "path": "scheduler/status-change-uploads",
    //                           "buttonName": "Status Change Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status",
    //                           "path": "scheduler/upload-status",
    //                           "buttonName": null
    //                       }
    //                   ]
    //               },
    //               {
    //                   "hiringId": "4",
    //                   "routes": [
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "ROA Uploads",
    //                           "path": "scheduler/roa-uploads",
    //                           "buttonName": "Reject upload Without Event"
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Bulk Email Uploads",
    //                           "path": "scheduler/bulkemail-uploads",
    //                           "buttonName": "Bulk Email Upload",
    //                           "templateOptions": [
    //                               {
    //                                   "name": "Notification of ROA",
    //                                   "activityId": 200201,
    //                                   "processId": 10
    //                               },
    //                 {
    //                                   "name": "General Notification",
    //                                   "activityId": 100010,
    //                                   "processId": 10
    //                               }
    //                           ]
    //                       },
    //                       {
    //                           "subRole": "SCAD",
    //                           "menu": "Status",
    //                           "path": "scheduler/upload-status",
    //                           "buttonName": null
    //                       }
    //                   ]
    //               }
    //           ]
    //       },
    //       {
    //           "role": "SCAS",
    //           "routes": [
    //               {
    //                   "subRole": "SCAS",
    //                   "menu": "Dashboard",
    //                   "path": "scheduler/associate"
    //               }
    //           ],
    //           "processId": [
    //               40
    //           ]
    //       },
    //       {
    //           "role": "OFDA",
    //           "routes": [
    //               {
    //                   "subRole": "OFDA",
    //                   "menu": "Dashboard",
    //                   "path": "offerdb/associate"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "RECRUITER",
    //           "routes": [
    //               {
    //                   "subRole": "RECRUITER",
    //                   "menu": "Dashboard",
    //                   "path": "recruiter/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "RM",
    //           "routes": [
    //               {
    //                   "subRole": "RM",
    //                   "menu": "Dashboard",
    //                   "path": "rm/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "CnB",
    //           "routes": [
    //               {
    //                   "subRole": "CnB",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/cnbdashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "CnBAdmin",
    //           "routes": [
    //               {
    //                   "subRole": "CnBAdmin",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/cnbadmin"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "CnBExecutive",
    //           "routes": [
    //               {
    //                   "subRole": "CnBExecutive",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/cnbdashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "RH",
    //           "routes": [
    //               {
    //                   "subRole": "RH",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "TPD",
    //           "routes": [
    //               {
    //                   "subRole": "TPD",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/tpddashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "Rec_Lead",
    //           "routes": [
    //               {
    //                   "subRole": "Rec_Lead",
    //                   "menu": "Dashboard",
    //                   "path": "reclead/posting-approval"
    //               }
    //           ]
    //       },
    //     {
    //           "role": "RecLeadAM",
    //           "routes": [
    //               {
    //                   "subRole": "RecLeadAM",
    //                   "menu": "Dashboard",
    //                   "path": "recleadam/posting-approval"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "HR Operations",
    //           "routes": [
    //               {
    //                   "subRole": "HR Operations",
    //                   "menu": "Dashboard",
    //                   "path": "hroperations/resume-upload"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "Operations",
    //           "routes": [
    //               {
    //                   "subRole": "Operations",
    //                   "menu": "Dashboard",
    //                   "path": "operations/edit-source"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "OD",
    //           "routes": [
    //               {
    //                   "subRole": "OD",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/bpmoddashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "HiringManager",
    //           "routes": [
    //               {
    //                   "subRole": "HiringManager",
    //                   "menu": "Dashboard",
    //                   "path": "hiringmanager/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "Offer_Admin",
    //           "routes": [
    //               {
    //                   "subRole": "OfferAdmin",
    //                   "menu": "Dashboard",
    //                   "path": "offermicro/approval/adminOffer"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "IAPRec",
    //           "routes": [
    //               {
    //                   "subRole": "IAPRec",
    //                   "menu": "Dashboard",
    //                   "path": "iaprecruiter/dashboard"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "BGC Approver 1",
    //           "routes": [
    //               {
    //                   "subRole": "BGC Approver 1",
    //                   "menu": "Dashboard",
    //                   "path": "/offermicro/bgc/approval"
    //               }
    //           ]
    //       },
    //       {
    //           "role": "BGC Approver 2",
    //           "routes": [
    //               {
    //                   "subRole": "BGC Approver 2",
    //                   "menu": "Dashboard",
    //                   "path": "/offermicro/bgc/approval"
    //               }
    //           ]
    //       },
    //       {
    //          "role": "Docket Anchor",
    //          "routes": [
    //             {
    //               "subRole": "Docket Anchor",
    //                "menu": "Dashboard",
    //                "path": "docketanchor/dashboard"
    //             }
    //           ]
    //       }

    //   ])
    //   })
    // });
  }
  setRole(data) {
    //console.log(data);
    this.role.next(data);
  }

  getRole() {
    return this.role.asObservable();
  }
  setProcessId(data) {
    this.schedulerProcessId.next(data);
  }
  getProcessId() {
    return this.schedulerProcessId.asObservable();
  }
  getMaintenanceMode() {
    return this.http.get<any[]>('assets/cdn/json/maintenance-intap.json');
    // return this.fileservice.downloadJsonFile('maintenance-intap.json')
    // .then(content => {
    //   return content; // or wrap in an object if needed
    // })
    // .catch(error => {
    //   console.error('Failed to load maintenance mode config:', error);
    //   // fallback or default value
    //   return { maintenanceMode: false };
    // });
  }

  setSCADRoutes(routes) {
    this.scadRoutes = routes;
  }
  getSCADRoutes() {
    return this.scadRoutes;
  }
}
